import React, { useEffect, useState } from 'react';
import { DeptType, ECode, formatDeptPath, get, isEmpty, isNil } from '@libs/shared';
import { getDeptCardDetail } from '../../apis';
import { authModel } from '../../models';
import { platformIntl } from '../../constants';
import classNames from 'classnames';

interface DeptCardProps {
    deptId: string;
    className?: string;
    tenantId?: string;
}

/**
 * 部门信息卡片
 */
const DeptCard: React.FC<DeptCardProps> = (props) => {
    const { deptId, className, tenantId } = props;

    const safeTenantId = authModel.tenantId || tenantId || '';
    // '' 展示无法查看部门信息的提示
    const [viewInfo, setViewInfo] = useState<string>();

    useEffect(() => {
        fetchDeptInfo();
    }, []);

    const fetchDeptInfo = () => {
        if (!deptId || !safeTenantId) {
            return;
        }
        getDeptCardDetail(deptId, safeTenantId)
            .then((data) => {
                if (data.type === DeptType.corp_coop) {
                    return;
                }
                setViewInfo(
                    formatDeptPath({
                        hasCurrentDept: false,
                        deptPath: data.dept_path,
                        corpName: authModel.currentCorpName
                    })
                );
            })
            .catch((res) => {
                const err = get(res, 'response.data');
                if (err.code === ECode.DEPT_NOT_FOUND) {
                    // 部门不存在
                    setViewInfo('');
                }
            });
    };

    const renderDeptInfo = () => {
        if (isEmpty(viewInfo)) {
            return (
                <div className="popover-content-empty">{platformIntl.get('dept.empty.tip')}</div>
            );
        }

        return (
            <div className="popover-content">
                <div className="content-info">
                    <div className="info-item">
                        <div className="item-label">{platformIntl.get('department.belong')}:</div>
                        <div className="item-info">{viewInfo}</div>
                    </div>
                </div>
            </div>
        );
    };

    if (isNil(viewInfo)) {
        return null;
    }

    return <div className={classNames('fx-dept-card', className)}>{renderDeptInfo()}</div>;
};

export default DeptCard;
